import styled from 'styled-components';
import { ContainerRef } from '../../styles';


export const Container = styled(ContainerRef)`
padding: 0px;
width: 100%;
.ck-content{
    min-height: 200px !important;
}
`;